import { ModelsAccountStatus } from '@/api/generated-api'
import { isAthleteEnabled } from '@/lib/auth/athleteFeature'

// VERIFIED → ACTIVE — двухстадийный post-approval lifecycle клуба;
// IN_EDIT — временный статус ACTIVE-клуба, который отправил правку на модерацию
// (см. services/clubs/internal/service/application_workflow.go:93-96 и PRD 46400435).
// Все три означают, что club.id уже существует и клуб принадлежит owner-домену.
export const CLUB_POST_APPROVAL_STATUSES = [
  ModelsAccountStatus.AccountStatusVerified,
  ModelsAccountStatus.AccountStatusActive,
  ModelsAccountStatus.AccountStatusInEdit
] as const

export const isClubPostApproval = (
  status: string | null | undefined
): boolean =>
  status != null &&
  (CLUB_POST_APPROVAL_STATUSES as readonly string[]).includes(status)

export const CLUB_MODERATION_PINNED_STATUSES = [
  ModelsAccountStatus.AccountStatusDraft,
  ModelsAccountStatus.AccountStatusPendingDataSubmission,
  ModelsAccountStatus.AccountStatusPendingAdminApprove,
  ModelsAccountStatus.AccountStatusPendingModeration,
  ModelsAccountStatus.AccountStatusPendingApproveTransaction,
  ModelsAccountStatus.AccountStatusRejected,
  ModelsAccountStatus.AccountStatusChangesRequested,
  ModelsAccountStatus.AccountStatusNeedsRevision
] as const

export const isClubModerationPinned = (
  status: string | null | undefined
): boolean =>
  status != null &&
  (CLUB_MODERATION_PINNED_STATUSES as readonly string[]).includes(status)

// BAT-1104: an athlete reuses the club row, and GET /clubs/me adds its
// application status (gateway athleteApplicationStatus). BAT-597: Approved
// (an ACTIVE or IN_EDIT row) is live and opens the athlete's cabinet like an
// ACTIVE club; only Blocked (BLOCKED or DELETED) stays on the status page.
export interface ClubStatusSource {
  status?: string | null
  participant_type?: string | null
  application_status?: string | null
}

export const ATHLETE_STATUS_PAGE_PINNED = ['BLOCKED'] as const

// Behind the athlete flag: with it off an athlete keeps the club routes.
export const athleteApplicationStatusOf = (
  club: ClubStatusSource | null | undefined
): string | null =>
  isAthleteEnabled() && club?.participant_type === 'ATHLETE'
    ? club.application_status ?? null
    : null

export const isAthleteStatusPagePinned = (
  club: ClubStatusSource | null | undefined
): boolean =>
  (ATHLETE_STATUS_PAGE_PINNED as readonly string[]).includes(
    athleteApplicationStatusOf(club) ?? ''
  )

/** The club (or athlete) belongs on /clubs/moderation. */
export const isModerationPinnedClub = (
  club: ClubStatusSource | null | undefined
): boolean =>
  isClubModerationPinned(club?.status) || isAthleteStatusPagePinned(club)
